import { useContext } from "react"

import { tableContext } from "../utils"

export function useSelect() {
  const { onSelect, selectedRowMap = {} } = useContext(tableContext)

  return { onSelect, selectedRowMap }
}
